import Gallery from "../components/Galeria";

export default function GallerySection() {

    return (
       <section className="gallery-section" id="gallery">
            <Gallery/>
       </section>
    );
}
